'use strict';

import React, { Component } from 'react';
import styled from 'styled-components';

const openQuote = "„";
const closeQuote = "“";
const lineFeed = '\n';

var jsonData = require('./landingpagedata.json');

const bjornImage = "./assets/img/bjorn-profile.jpg";

export default class WhoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionTitle: jsonData.WhoTexts.sectionTitle,
      role:jsonData.WhoTexts.role,
      imageText: jsonData.WhoTexts.imageText,
    }
  }

  render() {
    return (
      <Container>
        <SectionTitle >{jsonData.WhoTexts.sectionTitle +" "+jsonData.WhoTexts.role} </SectionTitle>
        <WhoSection>
          {this._renderImageCard()}
          {this._renderData()}
        </WhoSection>
      </Container>
    );
  }

 _renderImageCard(){
   return (
     <ImageCard
        image={jsonData.WhoTexts.imageSrc}
        imageText={jsonData.WhoTexts.imageText}
        imageStyle={cardImageStyle}/>);
 }

  _renderData(){
    let result = [];
    let i = 0;
    jsonData.WhoTexts.textCards.forEach( (eachItem) => {
      i++;
      let key = "WhoTexts"+i;
      result.push(
        <TextCard
           key={key}
           style={cardContainerStyle}
           isQuote={eachItem.isQuote}
           title={eachItem.title}
           link={eachItem.link}
           excerpt={eachItem.excerpt}
         />
         );
    });
  return (result);
  }
}

class TextCard extends Component {
 constructor(props) {
   super(props);
   this.state = {
     title:props.title,
     excerpt:props.excerpt,
   }
 }

 render() {
   const  {title, excerpt, link, akey,isQuote} = this.props;
  
   if(isQuote){
     return (
       <CardNoHover key={akey}>
         <CardContent>
             <CardExcerpt style={{fontStyle:"italic"}}>
             {renderLineFeed(excerpt,false,isQuote)}
             </CardExcerpt>
         </CardContent>
       </CardNoHover>
     );
   }
   else{
     return (
       <Card key={akey}>
         <CardContent>
           <a style={cardLinkStyle} href={link}>
             <CardTitle>{title}</CardTitle>
             <CardExcerpt>
               {renderLineFeed(excerpt,false,isQuote)}
             </CardExcerpt>
           </a>
         </CardContent>
       </Card>
     );
   }
 }
}

function renderLineFeed(text, renderImageLabel, isQuote){
  if(isQuote){
    text =  openQuote + text + closeQuote;
 }

  let arr = text.split("YEAR_EXPERIENCE",2);
  if(arr.length > 1){
    text= arr[0]+  (new Date().getFullYear()-2000) +arr[1];
  }
  
  if(renderImageLabel){
    return text.split('\n').map((item, i) => {
        return <ImageLabelLineProd key={i}>{item}</ImageLabelLineProd>;
    });
  }
  else{
    return text.split('\n').map((item, i) => {
        return <p key={i}>{item}</p>;
    });
  }
}

 class ImageCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const  {image, imageStyle,imageText} = this.props;
    return (
      <CardNoHover>
        <CardImageColumn>
          <img src={image} style={imageStyle}/>
          <ImageLabel>
          {renderLineFeed(imageText,true)}
          </ImageLabel>
        </CardImageColumn>
      </CardNoHover>
    );
  }
}

/*
*  WhoContainer styles
*/
const Container = styled.section`
  display: flex;    
  position: relative;  
  flex-direction: row;
  flex-wrap: wrap;
  background:#909394;
`;

const SectionTitle = styled.section`
    display: flex 1;
    height: 60px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    margin-left: 1.8rem;
    color: #FFF;
    font-size: 1.3em;
    line-height: 1.2em;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;

const WhoSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const cardContainerStyle =  {
  padding: "20px 0 0",

};

/*
*  TextCard styles
*/
//styled components
const Card = styled.section`
  flex-direction:column;
  flex: 1;
  align-items: flex-start;

  margin: 0rem 1.8rem 2.4rem ;
  min-height: auto;
  min-width:300px;
  color: rgba(255,255,255,1.0);
  &:hover {
    box-shadow: rgba(39,44,49,0.07) 8px 28px 50px, rgba(39, 44, 49, 0.04) 1px 6px 12px;
    transition: all 0.4s ease;
    transform: translate3D(0, -1px, 0) scale(1.02);
  }
`;

const CardNoHover = styled.section`
  flex-direction:column;
  flex: 1;
  align-items: flex-start;

  margin: 0 1.8rem 2.4rem ;
  min-height: auto;
  min-width:300px;
  color: rgba(255,255,255,1.0);
`;


const CardContent = styled.section`
  min-width:25rem;
  width:100%;
  height:100;
`;

//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const cardLinkStyle =  {
  position: 'relative',
  //'flex-grow': '1',
  display: 'block',
  //padding: '25px 25px 0',
  color: '#343a40'
};

const CardTitle = styled.section`
    padding-bottom:15px;
    color: #FFF;
    margin-top: 0;
    font-size: 1.25em;
    line-height: 1.5em;
    font-weight:600;

`;

const CardExcerpt = styled.section`
    color: #FFF;
    font-size: 1.25em;
    line-height: 1.45em;
`;


/*
*  CardImage styles
*/
//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const cardImageStyle =  {
  minWidth: '300px',
  width: 'fit-content',
  height: 'auto'
};

const CardImageColumn = styled.section`
  flex: 2 2;
  flex-direction: column;
  min-width: 185px;
`;

const ImageLabel = styled.section`
    padding: 1.0rem 0 1.0rem 0;
    height: 100%;
    width: 100%;
  `;

  const ImageLabelLine = styled.section`
      color: #FFF;
      font-size: 1.0rem;
      line-height:1.2rem;
      text-align: left;
    `;

    const ImageLabelLineProd = styled.section`
        color: #FFF;
        font-size: 1.5rem;
        line-height:1.8rem;
        text-align: left;
      `;